import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
// layout
import { colors } from "../layout/constants";

const SingleQuestion = ({ activeQuestion, sendAnswer, setChoiceID }) => {
	const [selectedAnswer, setSelectedAnswer] = useState({ id: 0 });
	const [slideOut, setSlideOut] = useState(false);

	const sendSelectedAnswer = async () => {
		setSlideOut(true);
		sendAnswer(activeQuestion, selectedAnswer, null);
		setSelectedAnswer({ id: 0 });
	};

	useEffect(() => {
		setSlideOut(false);
	}, [activeQuestion]);

	useEffect(() => {
		setChoiceID(selectedAnswer);
	}, [selectedAnswer]);

	return (
		<QuestionsStyled slideOut={slideOut}>
			<FormControl className="form" component="fieldset">
				<div className="header-question">
					<h2 className="question-title">{activeQuestion.name}</h2>
					{activeQuestion.hint ? (
						<p className="hint">Tema: {activeQuestion.hint}</p>
					) : null}
				</div>
				<RadioGroup
					id={`question-${activeQuestion.id}`}
					aria-label={`project-${activeQuestion.id}`}
					name={`project-${activeQuestion.id}`}
				>
					{activeQuestion.choices.map((choice) => {
						return (
							<FormControlLabel
								id={`choice-${choice.id}`}
								key={choice.id}
								className={`question-option ${
									selectedAnswer.id === choice.id ? "active" : null
								}`}
								value={choice.content}
								control={<Radio />}
								label={choice.content}
								onChange={() => setSelectedAnswer(choice)}
							/>
						);
					})}
				</RadioGroup>

				<Button
					className="select-button"
					disabled={selectedAnswer.id == 0 ? true : false}
					variant="contained"
					color="primary"
					size="large"
					onClick={() => sendSelectedAnswer()}
				>
					Contestar pregunta
				</Button>
			</FormControl>
		</QuestionsStyled>
	);
};

const QuestionsStyled = styled.section`
	animation-name: ${(props) => (props.slideOut ? "slide-out" : "slide-in")};
	animation-duration: 1s;
	animation-fill-mode: forwards;

	.header-question {
		width: 100%;
		margin: 0 auto;
	}
	.hint {
		border-radius: 4px;
		background-color: ${colors.backgroundDark};
		color: #999;
		// font-weight: 600;
		font-size: 18px;
		padding: 0.5rem;
		margin: 10px 0;
		text-align: left;
	}

	.form {
		width: 100%;
	}

	.question-title {
		// font-weight: 600;
		// margin: 40px 0;
		margin-bottom: 10px;
		text-align: left;
	}

	.question-option {
		align-items: flex-start;
		border: 1px solid ${colors.helperGray};
		border-radius: 4px;
		background-color: white;
		color: #575757;
		margin: 5px 0;
		padding: 20px;
		text-align: left;

		&.active,
		:hover {
			border: 1px solid ${colors.helperGrayActive};
			color: black;
		}
	}

	.question-option:nth-child(odd) {
		background-color: #f5f5f5;
	}

	.MuiTypography-body1 {
		// font-size: 25px;
		line-height: 1.2;
	}

	.select-button {
		margin: 10px auto;
		width: 100%;
	}

	.MuiButton-contained {
		box-shadow: none;
		font-size: 20px;
		font-weight: 600;

		:hover {
			box-shadow: none;
		}
	}

	.MuiIconButton-colorSecondary {
		:hover {
			background-color: transparent;
		}
	}

	.MuiButton-containedPrimary {
		background-color: ${colors.primary};
		:hover {
			background-color: ${colors.primaryDark};
		}
		width: 60%;
	}

	.MuiRadio-colorSecondary.Mui-checked {
		color: ${colors.primaryLight};
	}

	.MuiRadio-root {
		color: ${colors.helperGray};
		background-color: white;
		margin-right: 10px;
		padding: 0;
	}

	.PrivateSwitchBase-root-5 {
		padding: 0;
		margin: 0 30px 0 0;
	}

	.MuiSvgIcon-root {
		height: 24px;
		width: 24px;
	}

	@keyframes slide-in {
		0% {
			opacity: 0;
			transform: translateX(200%);
		}
		100% {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes slide-out {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(-200%);
		}
	}
`;

export default SingleQuestion;
